import { render, staticRenderFns } from "./AnalystAdd.vue?vue&type=template&id=4420f6d2&"
import script from "./AnalystAdd.vue?vue&type=script&lang=js&"
export * from "./AnalystAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports